// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { generateId } from '../../_common/api/utility';
import Button from '../../_common/form/Button';
import GoogleMap from '../../_common/GoogleMap';
import Loading from '../../_common/Loading';
import Modal from '../../_common/Modal';
import Card from '../Card';
import Title from '../../_common/form/Title';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import { ForceNavigate } from '../ForceLocation';
import { HamQuest } from '../../../App';

const GMap = styled(GoogleMap)`
    width: 100%;
    min-height: 350px;
    height: 45vh;
    box-shadow: 0px 0px 4px 1px ${({ theme }) => theme.mobile.shadow};
    z-index: 2;
`
const Wrapper = styled.div`
    overflow: overlay;
`
const Row = styled.div`
    display: flex;
    justify-content: space-between;
`

const FindUs = () => {
    const {
        state: {
            active_user,
            site_config
        },
        getLocation
    } = useGlobalState();

    const [loc, setLoc] = useState({
        center: active_user.location || site_config.googleMap.center,
        zoom: site_config.googleMap.zoom,
    });

    useEffect(() => {
        if (!active_user.location.lat) {
            getLocation()
        }

        HamQuest.get(QuestRoute.locations, { cache: 'force-cache' })
            .then((res) => {
                setLoc({
                    ...loc,
                    markers: [
                        ...res,
                    ]
                })
            })
    }, [])

    useEffect(() => {
        if (active_user.location.lat) {
            setLoc({
                ...loc,
                center: active_user.location
            })
        }
    }, [active_user])

    const getDistance = (location, unit = '') => {
        if (!active_user.location) return;

        const loc = {
            lat: location.latitude,
            lng: location.longitude
        };
        const user = {
            lat: active_user.location.lat,
            lng: active_user.location.lng
        };

        const deg2rad = x => x * (Math.PI / 180);
        const rad2deg = x => x * (180 / Math.PI);
        const sin = x => Math.sin(x);
        const cos = x => Math.cos(x);
        const acos = x => Math.acos(x);

        return rad2deg(
            acos(
                sin(deg2rad(user.lat)) * sin(deg2rad(loc.lat)) +
                cos(deg2rad(user.lat)) * cos(deg2rad(loc.lat)) *
                cos(deg2rad(user.lng - loc.lng))
            )
        ) * 60 * 1.1515;
    }

    const translateUnit = (miles, unit) => {
        if (!miles) return;
        return (
            unit === 'K' ? `${(miles * 1.609344).toFixed(1)} km` :
                unit === 'M' ? `${(miles * 1609.344).toFixed(0)} m` :
                    `${(miles).toFixed(1)} m`
        );
    }

    const handleClick = (e) => {
        const address = `https://www.google.com/maps/dir/?api=1&destination=${e.address1 + ' ' + (e.address2 || '')}, ${e.city}` + (e.state ? (',' + e.state) : '') + (e.zip ? (',' + e.zip) : '');
        Modal.Show({
            title: 'Car Wash',
            body: e.address1,
            buttons: [
                <Button
                    key={generateId()}
                    href={address}
                    target='_blank'
                >Directions</Button>
            ]
        })
    }

    const centerMap = e => {
        setLoc({
            ...loc,
            center: {
                lat: e.latitude,
                lng: e.longitude
            }
        })
    }

    if (!loc.markers) return <Loading />

    return (
        <>
            <GMap
                config={loc}
                additionalOptions={{
                    scaleControl: false,
                    streetViewControl: false,
                    mapTypeControl: false,
                    zoomControl: false,
                    overviewMapControl: false,
                    fullscreenControl: false,
                    gestureHandling: 'greedy'
                }}
                markerClick={handleClick}
            />
            <Wrapper>
                {site_config.locations.sort((a, b) => getDistance(a) - getDistance(b)).map(e =>
                    <Card key={Math.random(1)} onClick={() => centerMap(e)} noSlide>
                        <Title>{e.city}</Title>
                        <Row>
                            <div>{e.address1}</div>
                            {/* <div>{`${e.address1 + ' ' + (e.address2 || '')}, ${e.city}` + (e.state ? (',' + e.state) : '') + (e.zip ? (',' + e.zip) : '')}</div> */}
                            <div>{translateUnit(getDistance(e))}</div>
                        </Row>
                        <Row>
                            <ForceNavigate id={e.id} />
                            <Button onClick={() => handleClick(e)}>Directions</Button>
                        </Row>
                    </Card>
                )}
            </Wrapper>
        </>
    );
}

export default FindUs